module.exports = __webpack_public_path__ + "img/1.-劳动人民文化宫九龙柏（袁方-摄）.6065b64c.jpg";